import LocalizedLink from '@/components/layout/LocalizedLink'
import { BookOpen } from 'lucide-react'
import Card from '@/components/ui/Card'
import { getLocalizedValue } from '@sakeena/shared'
import { useTranslation } from 'react-i18next'

export interface RelatedTopic {
  id: number
  title: any
  bookId: number
}

interface RelatedTopicsProps {
  topics: RelatedTopic[]
}

export default function RelatedTopics({ topics }: RelatedTopicsProps) {
  const { i18n } = useTranslation()
  const currentLang = i18n.language || 'ar'

  if (topics.length === 0) {
    return null
  }

  return (
    <Card className="p-4">
      <h3 className="text-lg font-bold text-gray-900 mb-4">مواضيع ذات صلة</h3>
      <div className="space-y-2">
        {topics.map((topic) => (
          <LocalizedLink
            key={topic.id}
            to={`/library/${topic.bookId}#topic-${topic.id}`}
            className="flex items-center gap-2 text-sm text-gray-700 hover:text-primary-600 transition-colors py-2"
          >
            <BookOpen className="w-4 h-4" />
            <span>{getLocalizedValue(topic.title, currentLang)}</span>
          </LocalizedLink>
        ))}
      </div>
    </Card>
  )
}
